module.exports = __webpack_public_path__ + "images/emoji/notebook.a070b40c98bb68d8ab03.png";